export default __webpack_public_path__ + "static/yahoofinance-0b8d39b00ef15e1b670928b79373ea90.svg";